/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'image': {
    width: 37,
    height: 28,
    viewBox: '0 0 37 28',
    data: '<path pid="0" d="M34 0a3 3 0 013 3v22a3 3 0 01-3 3H3a3 3 0 01-3-3V3a3 3 0 013-3h31zM12.532 13.587L2 21.017V25a1 1 0 00.883.993L3 26h31a1 1 0 00.993-.883L35 25v-3.127l-7.386-5.39-5.41 3.51a2.003 2.003 0 01-2.253-.05l-.138-.11-7.28-6.246zM34 2H3a1 1 0 00-.993.883L2 3v15.57l9.38-6.617a2 2 0 012.32.01l.135.106 7.28 6.247 5.41-3.511a2 2 0 012.131-.03l.137.092L35 19.397V3a1 1 0 00-.883-.993L34 2z"/><path pid="1" d="M21 5c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 2a2 2 0 10-.001 3.999A2 2 0 0021 7z"/>'
  }
})
